///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';

import { Password } from './password.service';
import { Principal } from '../../shared/auth/principal.service';
import { finalize, from, Observable } from 'rxjs';
import { UserDTO } from '../../generated/shared-types.model';
import { LoaderIds, PreloaderService } from '../../services/preloader.service';
import { SuiTypeString } from '@siklu/sui-lib/infrastructure';
import { createPasswordFieldsPair } from '../../shared/password-field.generator';

@Component({
    selector: 'winde-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss'],
    standalone: false
})
export class PasswordComponent {
    public passwordChangeAttempted = false;
    public requestResult: { isSuccess: boolean; message: string } = { isSuccess: false, message: '' };
    public readonly loaderKey = LoaderIds.CHANGE_PASSWORD_ID;
    public newPassword: SuiTypeString;
    public confirmationPassword: SuiTypeString;
    public account$: Observable<UserDTO> = from(this.principal.identity(true));

    constructor(
        public readonly preloaderService: PreloaderService,
        private readonly passwordService: Password,
        private readonly principal: Principal
    ) {
        [this.newPassword, this.confirmationPassword] = createPasswordFieldsPair();
    }

    public changePassword(): void {
        if (!this.newPassword.validateAndShowError() || !this.confirmationPassword.validateAndShowError()) {
            return;
        }

        this.preloaderService.show(this.loaderKey);
        this.passwordService
            .save(this.newPassword.value)
            .pipe(
                finalize(() => {
                    this.preloaderService.hide(this.loaderKey);
                    this.passwordChangeAttempted = true;
                    setTimeout(() => (this.passwordChangeAttempted = false), 5000);
                })
            )
            .subscribe({
                next: () => {
                    this.requestResult.isSuccess = true;
                    this.requestResult.message = 'password.messages.success';
                },
                error: () => {
                    this.requestResult.isSuccess = false;
                    this.requestResult.message = 'password.messages.error';
                }
            });
    }
}
